exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-input-icon[data-v-1c1aa74d]{color:#a6a6a6;margin:1px 8px 0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);position:absolute}.vc-input-icon.vc-input-icon-preffix[data-v-1c1aa74d]{left:0}.vc-input-icon.vc-input-icon-subffix[data-v-1c1aa74d]{right:0}", ""]);

// exports
